import { render, staticRenderFns } from "./AdditionalInsurance.vue?vue&type=template&id=47b0d0a5"
import script from "./AdditionalInsurance.vue?vue&type=script&lang=js"
export * from "./AdditionalInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports